import React, { useState, useContext, useEffect } from "react";
import { showInfoToast } from "../../validation/ToastContainer";
import { getConfirmPopup } from "../../view/popup/PopupContainer";
import { PopupContext } from "../../index"
import { saveMLToleranceValue, getMLToleranceValue } from "../system-settings/systemSettingsService";


export default function MLToleranceSection() {

  const { setPopup } = useContext(PopupContext);
  const [tolerance, setTolerance] = useState('0');

  const isStartDisabled = false;

  const fetchData = async () => {
    try {
      let x = await getMLToleranceValue();
      setTolerance(x.value);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSetMLToleranceClick = event => {
    showInfoToast('Setting ML Tolerance', 'ML Tolerance');

    setPopup(
      getConfirmPopup('Are you sure?',
        'Octopus VAR ML Tolerance',
        () => onConfirm()
      )
    );

    const onConfirm = async () => {
      saveMLToleranceValue(tolerance);
    };
  };

  const changeToleranceValue = (value) => { setTolerance(value); }

  return (
    <>
      <p className="oct_settings-description">
        ML Tolerance: How much machine-learning result can be different and still be acceptable.
      </p>

      <div className="oct_settings-form-grid">
        <div className="oct_settings-field">
          <label className="oct_settings-label">ML Tolerance</label>
          <input
            className="oct_settings-input-v2"
            type="number"
            value={tolerance}
            onChange={event => changeToleranceValue(event.target.value)}
          />
        </div>
        <div className="oct_settings-field">
          <label className="oct_settings-label">Unit</label>
          <select className="oct_select-v2" disabled>
            <option value="%">%</option>
          </select>
        </div>
      </div>

      <button
        className={`oct_settings-btn-v2 ${isStartDisabled ? 'disabled' : ''}`}
        onClick={onSetMLToleranceClick}
      >
        Save ML Tolerance (%)
      </button>
    </>
  );
}
